import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// components
import ContentLayout from "@/layouts/ContentLayout";
import TitleBanner from "@/components/banners/TitleBanner";

// assets
import banner from "@/assets/images/blog/banner.png";
import demoImage from "@/assets/images/blog/demo-image.png";

// i18n
import { useTranslation } from "react-i18next";

interface Blog {
  id: string;
  title: string;
  category: string;
  date: string;
  descriptions: string[];
  images: string[];
}

const Blog = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState<Blog[]>([]);

  useEffect(() => {
    // Dynamic import based on language
    import(`@/assets/blogs/${i18n.language.toLowerCase()}.json`)
      .then((module) => {
        setBlogs(module.default);
      })
      .catch((error) => {
        // Fallback to English if translation doesn't exist
        import("@/assets/blogs/en.json").then((module) => {
          setBlogs(module.default);
        });
      });
  }, [i18n.language]);

  return (
    <div className="w-full">
      <TitleBanner bannerImg={banner} title={t("blog.blog")} />
      <ContentLayout>
        <section className="w-full">
          {/* <header className="w-full text-2xl font-extrabold leading-9 text-primary">
              {blog.title}
            </header> */}
          <section className="mt-6 flex w-full flex-wrap items-center gap-6">
            {blogs.map((blog) => (
              <figure
                className="h-[328px] w-[282px] cursor-pointer rounded-lg bg-[#f0f0f3] p-[15px] hover:opacity-80"
                key={blog.id}
                onClick={() => navigate(`/blog/${blog.id}`)}
              >
                <figure className="flex h-[178px] w-full items-center justify-center overflow-hidden rounded-[4px]">
                  <img src={demoImage} alt="" className="h-full w-full object-cover" />
                </figure>
                <div className="mt-[10px] flex w-full items-center gap-3 text-sm leading-[25px] text-[#4a4a4d]">
                  <span className="w-fit font-semibold">{blog.category}</span>
                  <span className="h-3 w-[1px] bg-[#4a4a4d]"></span>
                  <span className="w-fit font-normal">{blog.date}</span>
                </div>
                <p className="mt-[10px] line-clamp-3 text-base font-medium leading-[25px] text-[#474747]">
                  {blog.title}
                </p>
              </figure>
            ))}
          </section>
        </section>
      </ContentLayout>
    </div>
  );
};

export default Blog;
